import { useContext } from "react";
import { ScreenPropsContext } from "../../context/ScreenPropsContext";
import { useSelector } from "react-redux";
import CruzeiroApi from "../../components/utils/CruzeiroApi";

export const RedirectHelper = () => {
  const screenProps = useContext(ScreenPropsContext);

  const { routes, dataHelper, userHelper, history } = screenProps;

  const { disableLogin } = useSelector((state) => state.membership);

  const handleIngressoButton = async (redirect_uri) => {
    const user = await userHelper.getUser();

    if (!disableLogin && (!user || Object.keys(user).length === 0)) {
      history.push(routes.login.path, {
        redirectUrl: routes.socioSSO.path,
      });
      return;
    }

    await CruzeiroApi.goToSocio(
      user?.LoyaltyEmail__c,
      redirect_uri,
      dataHelper
    );
  };

  const redirectTo = async (AppScreen, RedirectId) => {
    switch (AppScreen) {
      case "Webview":
        if (RedirectId) {
          window.open(RedirectId, "_blank");
        }
        break;
      case "HomeScreen":
        history.push(`/${RedirectId}`);
        break;
      case "MatchDay":
        history.push(`/partida/${RedirectId}`);
        break;
      case "NewsScreen":
        history.push(`/noticias/${RedirectId}`);
        break;
      case "ProfileEdit":
        window.location.href = routes.profile.path;
        break;
      case "CaseScreen":
        window.location.href = routes.caseNew.path;
        break;
      case "TicketScreen":
        await handleIngressoButton(RedirectId);
        break;
      default:
      // console.log(AppScreen, RedirectId)
    }
  };

  return { redirectTo };
};
